<!-- Modal Backdrop -->
<div 
  *ngIf="isOpen" 
  class="modal-backdrop"
  (click)="onBackdropClick($event)"
>
  <!-- Modal Container -->
  <div 
    #modalContainer
    class="modal-container"
    [ngClass]="[
      'modal-' + size,
      hasFooterContent ? 'has-footer' : '',
      hasHeaderContent ? 'no-default-header' : 'has-default-header'
    ]"
    (click)="$event.stopPropagation()"
  >
    <!-- Resize handles removed - expand functionality disabled -->

    <!-- Modal Header -->
    <div
      class="modal-header"
      *ngIf="!hasHeaderContent">
      <h4 class="modal-title">{{ title }}</h4>
      <button
        *ngIf="closable"
        type="button"
        class="modal-close-btn"
        (click)="close()"
        title="Close modal"
        aria-label="Close"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <ng-content></ng-content>
    </div>

    <!-- Modal Footer (optional, will show if content is projected) -->
    <div class="modal-footer" *ngIf="hasFooterContent">
      <ng-content select="[slot=footer]"></ng-content>
    </div>
  </div>
</div> 
